export default function ChevronThickIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill="#D9D9D9" {...props}>
      <path d="M11 2 9.5.5 3 7l6.5 6.5 1.501-1.5L6 7l5-5Z" />
    </svg>
  );
}
